import { NgModule } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { CommonModule } from '@angular/common'
import { TemplateDialogComponent } from '@tv3/containers/templates/template-dialog/template-dialog.component'
import { SaveTemplateDialogComponent } from '@tv3/containers/templates/save-template-dialog/save-template-dialog.component'
import { EditorEmailComponent } from '@tv3/containers/templates/template-editor/editor-email/editor-email.component'
import { EditorPlaintextComponent } from './template-editor/editor-plaintext/editor-plaintext.component'
import { EditorHttpComponent } from '@tv3/containers/templates/template-editor/editor-http/editor-http.component'
import { TemplateEditorComponent } from './template-editor/template-editor.component'
import { ChannelsLibraryModule } from '@tokeet-frontend/channels'
import { TemplateDialogService } from './template-dialog/template-dialog.service'

const components = [
  //
  EditorEmailComponent,
  EditorPlaintextComponent,
  EditorHttpComponent,
  TemplateEditorComponent,
  TemplateDialogComponent,
  SaveTemplateDialogComponent,
]

const services = [TemplateDialogService]

@NgModule({
  imports: [SharedModule, CommonModule, ChannelsLibraryModule],
  declarations: [...components],
  exports: [...components],
  providers: [...services],
})
export class TemplatesSharedModule {}
